import { CreditAccountPaymentTypeId, getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { QueryOptions } from '../../../services/dynamo'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { toList } from '../../../utils/listUtils'
import { ListResponse, useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { HoardOrder } from '../state/types'

export const useHoardLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { find } = useStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findHoard = (id?: string) => find(TableName.HOARD_ORDERS, id) as O<HoardOrder>

        const loadAllHoards = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter(true) : undefined
            const response = await loadMultiple(TableName.HOARD_ORDERS, options)
            return response.dataTypes as HoardOrder[]
        }
        
        const loadHoardsBatch = async (options?: QueryOptions) => {
            const { loadMultiple } = loaders(companyId)
            return loadMultiple(TableName.HOARD_ORDERS, options) as Promise<ListResponse<HoardOrder>>
        }

        // TODO analizar los de abajo de esta linea 1 por 1 si se puede reemplazar por loadSalesBatch

        const loadHoard = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.HOARD_ORDERS, id, dbRequest) as Promise<O<HoardOrder>>
        }

        const loadHoards = (
            ids: string[],
            dbRequest = false
        ) => {
            const { loadByIds } = loaders(companyId)
            return loadByIds(TableName.HOARD_ORDERS, ids, dbRequest) as Promise<HoardOrder[]>
        }

        const loadBranchHoards = async (branchId: string) => {
            const { loadMultiple } = loaders(companyId)
            const options = {
                valueFilters: [
                    { prop: 'branchId', value: branchId },
                    { prop: 'archived', value: true, equals: false }
                ]
            }
            const response = await loadMultiple(TableName.HOARD_ORDERS, options)
            return response.dataTypes as HoardOrder[]
        }

        const loadCreditAccountHoards = async (dbRequest = false) => {
            const { loadFiltered } = loaders(companyId)
            const params = { paymentTypeId: CreditAccountPaymentTypeId }
            return loadFiltered(TableName.HOARD_ORDERS, dbRequest, params) as Promise<HoardOrder[]>
        }

        const loadCustomersHoards = (
            customerIds: string[],
            dbRequest = false
        ) => {
            const { loadFilteredByList } = loaders(companyId)
            return loadFilteredByList(TableName.HOARD_ORDERS, dbRequest, 'customerId', customerIds) as Promise<HoardOrder[]>
        }

        const loadHoardsWithProp = async (
            propName: string,
            dbRequest = false
        ) => {
            const { loadFiltered } = loaders(companyId)
            return loadFiltered(TableName.HOARD_ORDERS, dbRequest, undefined, undefined, toList(propName)) as Promise<HoardOrder[]>
        }

        const countHoards = (propName: string, propValue: string) => {
            const options = {
                valueFilters: [{
                    value: propValue,
                    prop: propName
                }],
                limit: 1
            }
            const { count2 } = loaders(companyId)
            return count2(TableName.HOARD_ORDERS, options)
        }

        return {
            findHoard,
            loadHoardsBatch,
            loadAllHoards,
            loadHoard,
            loadHoards,
            loadBranchHoards,
            loadCreditAccountHoards,
            loadCustomersHoards,
            loadHoardsWithProp,
            countHoards
        }
    }
}
